import { AdminGetOrganizationResponseDto, AdminService, PrismaOrganizationDto } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.detail>>;

export type TAdminOrganizationDetails = AdminGetOrganizationResponseDto &
  Partial<Pick<PrismaOrganizationDto, 'managementSource' | 'externalManagerName'>>;

export const createFetchOrganizationQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams): Promise<TAdminOrganizationDetails> =>
    call(() => cancelOnSignal(AdminService.getOrganization({ organizationId }), signal));
